import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function AppIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M8 4C5.79086 4 4 5.79086 4 8V24C4 26.2091 5.79086 28 8 28H24C26.2091 28 28 26.2091 28 24V8C28 5.79086 26.2091 4 24 4H8ZM12 15C12 14.4477 12.4477 14 13 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H13C12.4477 16 12 15.5523 12 15ZM12 19C12 18.4477 12.4477 18 13 18H15C15.5523 18 16 18.4477 16 19C16 19.5523 15.5523 20 15 20H13C12.4477 20 12 19.5523 12 19Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<AppIcon fill={props.fill} />
		</div>
	);
}